<template>
    <section class="contacts">
        <section class="contacts__head">
            <h1 class="contacts__head__title">{{$t('com.file.email.email-messages')}}</h1>
            <section class="contact-top__action-buttons">
                <ButtonGroup>
                    <ButtonBasic color="danger" size="md" @click="(e) => sendEmailToUsers()" style="padding: 10px 30px;">
                        <ButtonIcon icon="plus-small" />
                        {{$t('com.file.email.send-email')}}
                    </ButtonBasic>
                    <ButtonSeparator />
                    <ButtonSeparator />
                    <ButtonBasic color="danger" size="md" style="padding: 10px 30px;" @click="$store.commit('setExportEmailModalStatus', true)">
                        <ButtonIcon icon="download" />
                        {{$t('com.file.email.export')}}
                    </ButtonBasic>
                </ButtonGroup>
            </section>
        </section>
        <section class="contacts__statistics">
            <GenericStatisticsBoxVue :label="$t('com.file.email.send-today')"
                                     :value="emailStatistics.today"
                                     :icon="'send_e-mail'" />
            <GenericStatisticsBoxVue :label="thisMonthStaticLabel"
                                     :value="emailStatistics.thisMonth"
                                     :icon="'send_e-mail'" />
            <GenericStatisticsBoxVue :label="lastMonthStaticLabel"
                                     :value="emailStatistics.lastMonth"
                                     :icon="'send_e-mail'" />
            <GenericStatisticsBoxVue :label="thisYearStaticLabel"
                                     :value="emailStatistics.thisYear"
                                     :icon="'send_e-mail'" />
        </section>
        <section class="contact-top">
            <section class="contact-top__search">
                <form class="contact-top__form">
                    <section class="contact-top__form__item">
                        <SearchLabelComponent :label="$t('com.file.email.search-message')" />
                        <SearchInputTextComponent v-model="internalRequestQuery.searchText"
                                                  :placeholder="$t('com.file.email.search-message')+'...'" />
                    </section>
                    <section class="contact-top__form__item">
                        <SearchLabelComponent :label="$t('com.file.announcements.date-from')" />
                        <SearchInputDateComponent v-model="internalRequestQuery.dateFrom" />
                    </section>
                    <section class="contact-top__form__item">
                        <SearchLabelComponent :label="$t('com.file.announcements.date-to')" />
                        <SearchInputDateComponent v-model="internalRequestQuery.dateTo" />
                    </section>
                </form>
            </section>
        </section>
        <Pagination :totalItems="paginatedData.totalItems"
                    :currentPage="paginatedData.currentPage"
                    :itemsPerPage="paginatedData.itemsPerPage"
                    @goToPage="changePage" />
        <section class="contacts__list" v-if="email.length > 0">
            <section class="contact-list">
                <section v-for="s in checkFilter" :key="s.id">
                    <section class="contact-box">
                        <section class="contact-box__top"
                                 @click="openMessage(s.id)">
                            <section>
                                <!--<span class="contact-box__title">Od: <b>{{ s.from }}</b> do: <b>{{s.to}}</b> ({{formatDateToDisplay(s.time)}}) </span>-->
                                <span class="contact-box__title">{{$t('com.file.email.to')}}: <b>{{s.to}}</b> ({{formatDateToDisplay(s.time)}}) </span>
                                <img src="@/assets/icons/panel/Contacts/list-arrow.svg"
                                     class="contact-box__arrow"
                                     :class="{ 'contact-box__arrow--open': s.show }" />
                            </section>
                        </section>
                        <section style="padding: 10px" class="contact-box__people contact-box__people--open" v-if="s.show">
                            <section v-if="s.text.length > 0">
                                <section class="contact-box__people-container">
                                    <h4 style="margin-bottom: 10px;">{{$t('com.file.send-meeting-regarding.topic-label')}}: {{s.subject}}</h4>
                                    <span v-html="formatText(s.text)"></span>
                                </section>
                            </section>
                        </section>
                    </section>
                </section>

            </section>
        </section>
        <section class="contacts__list" v-else>
            <section class="contact-list">
                <section>
                    <section class="contact-box">
                        <section class="contact-box__top">
                            <section>
                                <span class="contact-box__title">{{$t('com.file.email.no-emails')}}</span>
                            </section>
                        </section>
                    </section>
                </section>
            </section>
        </section>
        <Pagination :totalItems="paginatedData.totalItems"
                    :currentPage="paginatedData.currentPage"
                    :itemsPerPage="paginatedData.itemsPerPage"
                    @goToPage="changePage" />
        <Transition>
            <EmailModal v-if="showEmailModal" @closeEmail="closeEmailModal" :options="emailOptions" :selected="selectedEmail" />
        </Transition>
        <Transition>
            <ExportEmailModal v-if="$store.state.modals.tools.exportEmailModalStatus" />
        </Transition>   
    </section>
</template>

<script charset="utf-8">
    import GenericStatisticsBoxVue from "@/components/BasicControls/GenericStatisticsBox.vue";
    import SearchLabelComponent from "@/components/BasicControls/SearchLabelComponent.vue";
    import SearchInputTextComponent from "@/components/BasicControls/SearchInputTextComponent.vue";
    import SearchInputDateComponent from "@/components/BasicControls/SearchInputDateComponent.vue";
    import Pagination from "@/components/BasicControls/Pagination.vue";
    import CommunicationService from "@/services/communication.service";
    import ContactService from "@/services/contact.service";
    import EmailModal from "@/components/Panel/Content/Home/Modals/SendEmail.vue";
    import CommonHelper from "@/helpers/common.helper";
    import AlertHelper from "@/helpers/alerts.helper";
    import ExportEmailModal from "./Modals/ExportEmailModal.vue";
    import { formatDateToDisplay } from "../../../../../helpers/i18n.utils";
    export default {
        name: "email",
        data() {
            return {
                searchBar: "",
                email: [],
                showEmailModal: false,
                page: 1,
                selectedEmail: [],
                emailOptions: [],

                paginatedData: {
                    currentPage: -1,
                    itemsPerPage: 10,
                    totalItems: -1,
                },

                internalRequestQuery: {
                    searchText: null,
                    searchStatus: null,
                    dateFrom: null,
                    dateTo: null,
                    page: 1,
                    itemsPerPage: 10,
                },
                emailStatistics: {
                    today: 0,
                    thisMonth: 0,
                    lastMonth: 0,
                    thisYear: 0,
                    lastYear: 0,
                },
                isLoading: {
                    data: false,
                    statistics: false,
                },
                monthLabelDictionary: {
                    0: this.$t('com.file.email.in-january'),
                    1: this.$t('com.file.email.in-february'),
                    2: this.$t('com.file.email.in-march'),
                    3: this.$t('com.file.email.in-april'),
                    4: this.$t('com.file.email.in-may'),
                    5: this.$t('com.file.email.in-june'),
                    6: this.$t('com.file.email.in-july'),
                    7: this.$t('com.file.email.in-august'),
                    8: this.$t('com.file.email.in-september'),
                    9: this.$t('com.file.email.in-october'),
                    10: this.$t('com.file.email.in-november'),
                    11: this.$t('com.file.email.in-december')
                }
            };
        },
        watch: {
            isLoading: {
                deep: true,
                handler: function (value) {
                    if (value.data === false && value.statistics === false) {
                        this.$store.commit("hideLoader");
                    }
                    else {
                        this.$store.commit("showLoader");
                    }
                }
            },
            internalRequestQuery: {
                deep: true,
                handler: function (newValue) {
                    let queryParam = CommonHelper.getNonNullObjectEntries(newValue);
                    this.$router.replace({ name: "email", query: queryParam });
                    //this.fetchSmsData();
                    //this.fetchSessions(queryParam);
                }
            },
            $route() {
                if (this.$route.name === "email" && Object.keys(this.$route.query).length > 0) {
                    this.queryParamsToRequestSearch();
                    this.fetchEmailData();
                }

            },

            isAnyModalOpen: {
                deep: true,
                handler: function (val) {
                    document.querySelector('body').style.overflow = val ? 'hidden' : 'auto';
                }
            },
        },
        computed: {
            checkFilter() {
                return this.email.filter((item) => {
                    var elem = String(item.from + " " + item.to + " " + this.formatDateToDisplay(item.time))
                    return elem.toLowerCase().includes(this.searchBar.toLowerCase());
                });
            },
            requestQuery() {
                return this.$route.query;
            },

            isAnyModalOpen(){
                return this.showEmailModal
            },
            thisYearStaticLabel(){
                const date = new Date();
                const inn = this.$t('com.file.email.in');
                return `${inn} ${date.getFullYear()}`
            },
            thisMonthStaticLabel(){
                const date = new Date();
                const inn = this.$t('com.file.email.in');
                return `${inn} ${this.monthLabelDictionary[date.getMonth()]}`;
            },
            lastMonthStaticLabel(){
                const date = new Date();
                const lastDate = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
                const inn = this.$t('com.file.email.in');
                return `${inn} ${this.monthLabelDictionary[lastDate.getMonth()]}`;
            }
        },
        async mounted() {
            this.fetchEmailStatistics();
            if (CommonHelper.isObjectIsEmpty(this.requestQuery)) {
                this.setDefaultRequestQuery();
            }
            else {
                this.queryParamsToRequestSearch();
                await this.fetchEmailData();
            }
        },
        methods: {
            containsHTML(str) {
                const doc = new DOMParser().parseFromString(str, "text/html");
                return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
            },

            formatText(s) {
                if (s == null || s == undefined) return "";

                if (!s || typeof s !== "string") return s;

                if (!this.containsHTML(s)) {
                    s = s.replace(/\n/g, '<br />');
                }

                return s;
            },

            async fetchEmailData() {
                try {
                    this.isLoading.data = true;
                    //this.$store.commit("showLoader");
                    let requestData = this.internalRequestDataToAsyncRequestData();
                    let response = await CommunicationService.searchEmails(requestData);
                    if (response.status !== 200) {
                        throw await Promise.reject(response)
                    }

                    if (response.data.items != null)
                        this.email = response.data.items;

                    if (response.data.paginated)
                        this.paginatedData = response.data.paginated;
                }
                catch (e) {
                    if (e.response.status == 404) {
                        this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'email' } });
                    }
                    else if (e.response.status == 401) {
                        this.$router.push({ name: 'Login' })
                    }
                }
                finally {
                    this.isLoading.data = false;
                    //this.$store.commit("hideLoader");
                }
            },

            async fetchEmailStatistics() {
                try {
                    this.isLoading.statistics = true;

                    let response = await CommunicationService.getEmailStatistics();

                    if (response.status !== 200) {
                        throw await Promise.reject(response)
                    }
                    this.emailStatistics = response.data;
                }
                catch (e) {
                    if (e.response.status == 404) {
                        this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'email' } });
                    }
                    else if (e.response.status == 401) {
                        this.$router.push({ name: 'Login' })
                    }
                }
                finally {
                    this.isLoading.statistics = false;
                }
            },

            internalRequestDataToAsyncRequestData() {
                return {
                    data: {
                        searchText: this.internalRequestQuery.searchText,
                        searchStatus: this.internalRequestQuery.searchStatu,
                        dateFrom: this.internalRequestQuery.dateFrom,
                        dateTo: this.internalRequestQuery.dateTo,
                    },
                    paginated: {
                        page: this.internalRequestQuery.page,
                        itemsPerPage: this.internalRequestQuery.itemsPerPage,
                    }
                }
            },

            setDefaultRequestQuery() {
                this.clearRequestData();
                let queryParam = CommonHelper.getNonNullObjectEntries(this.internalRequestQuery);
                this.$router.replace({ name: "email", query: queryParam });
            },
            changePage(page) {
                this.internalRequestQuery.page = page;
            },
            clearRequestData() {
                this.internalRequestQuery.searchText = null;
                this.internalRequestQuery.searchStatus = null;
                this.internalRequestQuery.dateFrom = null;
                this.internalRequestQuery.dateTo = null;
                this.internalRequestQuery.page = 1;
                this.internalRequestQuery.itemsPerPage = 10;
            },

            queryParamsToRequestSearch() {

                if (CommonHelper.isObjectHasProperty(this.requestQuery, "searchText")) {
                    this.internalRequestQuery.searchText = this.requestQuery.searchText;
                }

                if (CommonHelper.isObjectHasProperty(this.requestQuery, "dateFrom")) {
                    this.internalRequestQuery.dateFrom = this.requestQuery.dateFrom;
                }

                if (CommonHelper.isObjectHasProperty(this.requestQuery, "dateTo")) {
                    this.internalRequestQuery.dateTo = this.requestQuery.dateTo;
                }

                if (CommonHelper.isObjectHasProperty(this.requestQuery, "_r")) {
                    this.clearRequestData();
                }
            },

            async closeEmailModal() {
                await this.fetchEmailStatistics();
                this.showEmailModal = false;
            },
            async sendEmailToUsers() {
                try {
                    this.$store.commit('showLoader');
                    var result = (await ContactService.getUsersToSmsOrEmail(2)).data;
                    if (Object.keys(result).length > 0) {
                        this.emailOptions = result;
                        this.showEmailModal = true;
                    }
                    else {
                        this.$swal(AlertHelper.errorAlert(this.$t('com.file.email.no-contacts-emails-error'), this.$t('com.global.error')));
                    }
                } catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
                finally{
                    this.$store.commit('hideLoader');
                }
            },
            openMessage(id) {
                for (var i = 0; i < this.email.length; i++) {
                    if (this.email[i].id == id)
                        if (this.email[i].show == false)
                            this.email[i].show = true;
                        else
                            this.email[i].show = false;
                }
            },
            formatDateToDisplay,
            async nextPage() {
                this.page += 1;
                try {
                    this.email = [];
                    this.$store.commit("showLoader");
                    this.email = (await CommunicationService.getEmails(this.page)).data;
                    for (var i = 0; i < this.email.length; i++) {
                        this.email[i].show = false;
                    }
                    this.$store.commit("hideLoader");
                } catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },
            async previousPage() {
                if (this.page > 1) {
                    this.page -= 1;
                    try {
                        this.email = [];
                        this.$store.commit("showLoader");
                        this.email = (await CommunicationService.getEmails(this.page)).data;
                        for (var i = 0; i < this.email.length; i++) {
                            this.email[i].show = false;
                        }
                        this.$store.commit("hideLoader");
                    } catch (e) {
                        if (e.response.status == 401)
                            this.$router.push({ name: 'Login' })
                    }
                }
            }
        },
        components: {
            EmailModal,
            Pagination,
            SearchInputTextComponent,
            SearchInputDateComponent,
            SearchLabelComponent,
            GenericStatisticsBoxVue,
            ExportEmailModal
        }
    };
</script>

<style lang="scss" scoped>
    @use  "@/assets/scss/search-component.scss";

    @media only screen and (max-width:1450px) {
        .contacts__statistics{
            .statistics-box{
                max-width: 240px !important;
                height: 130px !important;
            }
        }
    }
</style>
